import axios from 'axios';
import config from '../config';
import { requestConnectUser, requestLinkUser } from '../actions';

const AUTHENTICATION_API_URL = config.get('AUTHENTICATION_API_URL');

export const apiConnectUser = (token, request, appCallback) => {
    return async dispatch => {

        const dispatchError = (error) => {
            dispatch(
                {
                    type: 'FAIL_CONNECT_USER',
                    error: {
                        message:
                            error &&
                            error.response &&
                            error.response.data &&
                            error.response.data.message
                                ? error.response.data.message
                                : 'Unknown Error',
                        status:
                            error &&
                            error.response &&
                            error.response.status
                                ? error.response.status
                                : 500
                    }
                }
            )
        };

        dispatch(requestConnectUser());


        const {
            emailAddress,
            password,
            firstName,
            lastName,
            appId,
            clientId,
            userId,
            officeId,
            userGuid,
            officeGuid
        } = request;

        const url = `${AUTHENTICATION_API_URL}/connect-user`;

        const headers = {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        };

        const body = JSON.stringify({
            emailAddress,
            password,
            firstName,
            lastName,
            appId,
            clientId,
            userId,
            officeId,
            userGuid,
            officeGuid
        });

        //Authentication API Call
        axios
            .post(url, body, { headers })
            .then(apiResponse => {
                    //App Callback
                    if (apiResponse.data && apiResponse.data.id) {
                        let data = JSON.stringify({
                            userId: apiResponse.data.id,
                            emailAddress,
                            token: token
                        });
                        axios.post(appCallback, data, { headers })
                            .then(response => dispatch({ type: 'RECEIVE_CONNECT_USER', json: response.data }))
                            .catch(error =>
                                dispatchError(error)
                            );
                    } else {
                        dispatchError(
                            {
                                error: {
                                    message: 'Expected content not returned',
                                    status: 204
                                }
                            }
                        );
                    }
                }
            )
            .catch(error =>
                dispatchError(error)
            );
    };
};

export const apiLinkUser = (token, request, appCallback) => {
    return async dispatch => {

        const dispatchError = (error) => {
            dispatch(
                {
                    type: 'FAIL_LINK_USER',
                    error: {
                        message:
                            error &&
                            error.response &&
                            error.response.data &&
                            error.response.data.message ? error.response.data.message : 'Unknown Error',
                        status:
                            error &&
                            error.response &&
                            error.response.status ? error.response.status : 500
                    }
                }
            )
        };

        dispatch(requestLinkUser());


        const {
            emailAddress,
            password,
            firstName,
            lastName,
            appId,
            clientId,
            userId,
            officeId,
            userGuid,
            officeGuid
        } = request;

        const url = `${AUTHENTICATION_API_URL}/connect-user`;

        const headers = {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        };

        const body = JSON.stringify({
            emailAddress,
            password,
            firstName,
            lastName,
            appId,
            clientId,
            userId,
            officeId,
            userGuid,
            officeGuid
        });

        //Authentication API Call
        axios
            .patch(url, body, { headers })
            .then(apiResponse => {
                    //App Callback
                    if (apiResponse.data && apiResponse.data.id) {
                        let ssoData = JSON.stringify({
                            userId: apiResponse.data.id,
                            emailAddress,
                            token
                        });
                        axios.post(appCallback, ssoData, { headers })
                            .then(response => dispatch({ type: 'RECEIVE_LINK_USER', json: response.data }))
                            .catch(error =>
                                dispatchError(error)
                            );
                    } else {
                        dispatchError(
                            {
                                error: {
                                    message: 'Expected content not returned',
                                    status: 204
                                }
                            }
                        );
                    }
                }
            )
            .catch(error =>
                dispatchError(error)
            );
    };
};
